module.exports = __webpack_public_path__ + "static/media/controlShiftR.a54e339c.jpg";